import ScreenWrapper from "@/components/ScreenWrapper"
import CreateExamForm from "@/pages/toetsen/aanmaken/CreateExamForm"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/toetsen/aanmaken/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "exams"),
})

function RouteComponent() {
  return (
    <ScreenWrapper showManagementMenu>
      <CreateExamForm />
    </ScreenWrapper>
  )
}
